import React, { FC } from 'react';

import { useSession } from '../../providers';

export const OnlyWhenAuthenticated: FC = ({ children }) => {
  const [isAuthenticated] = useSession();

  return isAuthenticated ? <>{children}</> : null;
};
